<script lang="ts">
	import FacebookPixel from '$lib/addons/FacebookPixel.svelte';
	import Favicon from '$lib/addons/Favicon.svelte';
	import GoogleAnalytics from '$lib/addons/GoogleAnalytics.svelte';
	import MarketoMunchkin from '$lib/addons/MarketoMunchkin.svelte';
	import TwitterUniversal from '$lib/addons/TwitterUniversal.svelte';
	import Zendesk from '$lib/addons/Zendesk.svelte';
	import type { Addons } from '$lib/addons/Types';
	import { onMount } from 'svelte';
	import HubSpot from '$lib/addons/HubSpot.svelte';
	import Intercom from '$lib/addons/Intercom.svelte';
	import { toastMessages } from '$lib/stores/toastMessageStore';
	import { _ } from 'svelte-i18n';

	import { getHubStores } from '$lib/stores/hubStores';
	import CustomJs from '$lib/addons/CustomJS.svelte';
	const { hub, api } = getHubStores();

	let addons: Addons;
	let loaded = false;
	onMount(async () => {
		try {
			const addonsResponse = await api.listAddonsMap({
				hubId: $hub.id,
				filters: { disabled: false },
			});
			if (addonsResponse.addons.facebook_pixel) {
				// WebRPC is not able to give us better type safety here, so we just assume that if the facebook_pixel
				addons = addonsResponse.addons as unknown as Addons;
				loaded = true;
			}
		} catch (e) {
			toastMessages.danger($_('common.error.wrong'), e);
		}
	});
</script>

<svelte:head>
	{#if loaded}
		{#if addons.favicon.length}
			<Favicon url={addons.favicon[0]?.values.url || ''} />
		{/if}
		{#if addons.google_analytics.length}
			<GoogleAnalytics configs={addons.google_analytics} />
		{/if}
		{#if addons.twitter_universal_tag.length}
			<TwitterUniversal configs={addons.twitter_universal_tag} />
		{/if}
		{#if addons.facebook_pixel.length}
			<FacebookPixel configs={addons.facebook_pixel} />
		{/if}
		{#if addons.marketo_munchkin.length}
			<MarketoMunchkin configs={addons.marketo_munchkin} />
		{/if}
		{#if addons.zendesk_widget.length}
			<Zendesk configs={addons.zendesk_widget} />
		{/if}
		{#if addons.hubspot.length}
			<HubSpot configs={addons.hubspot} />
		{/if}
		{#if addons.intercom.length}
			<Intercom configs={addons.intercom} />
		{/if}
		<!-- {#if addons.custom_css.length}
			<CustomCss configs={addons.custom_css} />
		{/if} -->
		{#if addons.custom_js.length}
			<CustomJs configs={addons.custom_js} />
		{/if}
	{/if}
</svelte:head>
